module.exports = __webpack_public_path__ + "b8ad154105807b14e01c15b1b15b34dd.jpg";